
const TaxProductCat = {
  init() {
    console.log('tax cat init woo');
    TaxProductCat.events();
  },

  events() {
    // Buy now  button functionality
    $('.woo-item__btn-buy').on('click', function (e) {
      e.preventDefault();

      // Get the product quantity
      let quantity = 1;
      const prod_id = parseInt($(e.currentTarget).data('id'));
      const checkout_url = $(e.currentTarget).data('checkout');

      // Add the product to the cart using AJAX and redirect to checkout
      $.ajax({
        type: 'POST',
        url: ajaxurl,
        data: {
          action: 'add_to_cart',
          product_id: prod_id,
          quantity: quantity,
        }
      })
        .done((response) => {
          if (response.success) {
            window.location.href = checkout_url;
          }
        });
    });

    // Add to cart button functionality
    $('.woo-item__btn-basket').on('click', function (e) {
      e.preventDefault();

      let quantity = 1;
      const prod_id = parseInt($(e.currentTarget).data('id'));
      const icon = `<svg width="17" height="21" viewBox="0 0 17 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M0.53033 11.3876C0.823223 11.0947 1.2981 11.0947 1.59099 11.3876L5.06066 14.8573L14.5303 5.38764C14.8232 5.09475 15.2981 5.09475 15.591 5.38764C15.8839 5.68053 15.8839 6.15541 15.591 6.4483L5.59099 16.4483C5.2981 16.7412 4.82322 16.7412 4.53033 16.4483L0.53033 12.4483C0.237437 12.1554 0.237437 11.6805 0.53033 11.3876Z" fill="#A51E36" stroke="#A51E36" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>`;

      $.ajax({
        type: 'POST',
        url: ajaxurl,
        data: {
          action: 'add_to_cart',
          product_id: prod_id,
          quantity: quantity,
        }
      })
        .done((response) => {
          if (response.success) {
            $(e.currentTarget).html(`Pievienots ${icon}`);
            $('.header-button__number').html(response.data.cart_count);
            if ($('.header-button__number').hasClass('header-button__number--hidden')) {
              $('.header-button__number').removeClass('header-button__number--hidden');
            };
          }
        });
    });
  },

};

export default TaxProductCat;
